import React, { Component } from "react";
import { Select, Input, Button, Icon, Popover } from "antd";
import { connect } from "react-redux";
import {
  couponClearMessage,
  validateCoupon,
  GetLoyaltyRewardsOptions,
  validateCouponReset
} from "../../../redux/actions/generalActions";
import {
  getSignedInLoyalityRewards,
  GetLoyaltyRewardsCoupons,
} from "../../../redux/actions/membersActions";
import { SessionStorage } from "../../../helpers";
import { setLoginError } from "../../../redux/actions/betSlipActions";
import Loading from "../Loading";
import { Alert } from "../../";
import { validateSingleCoupon } from "../../../redux/actions/betSlipActions";

const Option = Select.Option;
const rewardInfoStyle = {
  backgroundColor: "transparent",
  border: "1px solid var(--white)",
};
export class LoyalityRewards extends Component {
  state = {
    loyalityCoupon: undefined,
    visible: false,
  };
  componentDidMount() {
    if (this.props.signedIn) {
      this.props.getSignedInLoyalityRewards();
    } else {
      this.props.GetLoyaltyRewardsOptions();
    }
  }

  loyalityRewardDroppDown = (value) => {
    console.log("value",value);
    this.props.validateCouponReset();
    const typeId = value.split("-")[0];
    const optionsTypeId = value.split("-")[1];
    const couponCode = value.split("-")[2];
    if (Number(optionsTypeId) == 3) {
      SessionStorage.betSlipCouponId = false;
      SessionStorage.couponCodeText = false;
      SessionStorage.couponCode = false;
      this.props.GetLoyaltyRewardsCoupons({ typeId: Number(typeId) });
      this.setState({ loyalityCoupon: "options" });
    } else if (Number(optionsTypeId) == 1) {
      SessionStorage.betSlipCouponId = false;
      SessionStorage.couponCodeText = false;
      this.setState({ loyalityCoupon: "check-coupon" });
    } else if (Number(optionsTypeId) == 2) {
      SessionStorage.betSlipCouponId = false;
      SessionStorage.couponCodeText = couponCode;
      SessionStorage.couponCode = false
      this.props.validateSingleCoupon();
      this.setState({ loyalityCoupon: "add-coupon" });
    }
  };
  SelectLoaylityRewardOption = (ele) => {
    SessionStorage.betSlipCouponId = ele;
    this.props.validateSingleCoupon();
  };
  showRewardInfo = (e, ele) => {
    e.stopPropagation();
    this.setState({
      expandedReward: ele,
    });
  };
  validateCouponCode = () => {
    let request = {
      couponCode: this.state.couponCode || SessionStorage.couponCode,
    };
    this.props.validateCoupon(request);
  };
  replaceWithBr =(Name) =>{
    return Name.replace(/\\n/g, "<br />")
  }

  addLineSpace=(data) => {
    console.log("!!data", data)
    return data && data.split('/n').map(function (item) {
      return (
        <span>
        {item}
        <br />
        </span>
      )
      })
    }
  
  render() {
    const {
      loyaltyRewardDetails,
      couponClearMessage,
      setLoginError,
      validateCouponMessage,
      validateCouponError,
      validateCouponLoading,
      loadingLoyalityRewards,
      loyalityRewardOptions,
      loyalityRewardOptionsError,
      loadingLoyaltyCoupons,
      loyaltyCoupons,
      loyaltyCouponsError,
      couponName,
      loadingPlaceBet,
      betSlipList
    } = this.props;
    let notSlotCoupoun = SessionStorage.couponCode && loyalityRewardOptions && loyalityRewardOptions.length > 0 && loyalityRewardOptions.filter(option=> option.couponCode == SessionStorage.couponCode.toUpperCase())
    let isSelectedCoupon = SessionStorage.couponCodeText && loyalityRewardOptions && loyalityRewardOptions.length > 0 && loyalityRewardOptions.filter(option=> option.couponCode == SessionStorage.couponCodeText.toUpperCase())
    const isSingleBetSucceeded =Object.values(betSlipList).filter(
      (bet) => bet.response
    ).length > 0 &&
    !Object.values(betSlipList).every(
      (bet) =>
        bet.response && bet.response.type === "error"
    )
    return (
      <div className="loyality-rewards-container">
        <Select
          placement="bottom"
          key={loyaltyRewardDetails  && loyalityRewardOptions && `${loyaltyRewardDetails.loyaltyRewardsImage}-${validateCouponLoading}-${loyalityRewardOptions.length}-${loadingPlaceBet}-${isSingleBetSucceeded}`}
          onSelect={this.loyalityRewardDroppDown}
          className="loyality-rewards-select"
          getPopupContainer={(trigger) => trigger.parentNode}
          listHeight={100}
          defaultValue={
            (notSlotCoupoun && notSlotCoupoun.length > 0) ? `0-2-${SessionStorage.couponCode.toLowerCase()}`:(isSelectedCoupon && isSelectedCoupon.length > 0) ? `0-2-${SessionStorage.couponCodeText.toLowerCase()}`: <div className="select-default-value">
              <img
                style={{ height: "25px", width: "25px", marginRight: "5px" }}
                src={loyaltyRewardDetails && loyaltyRewardDetails.loyaltyRewardsImage}
                alt="Rewards"
              />
              Loyality Rewards
            </div>
          }
          // options={['Option1' , 'Option2','Option3','Type coupon code'] }
        >
          {loadingLoyalityRewards ? (
            <Option className="select-options" key={"alert"}>
              <Loading text="Loading Options" />
            </Option>
          ) : loyalityRewardOptionsError ? (
            <Option className="select-options" key={"alert"}>
              <Alert
                message={loyalityRewardOptionsError}
                type="error"
                icon="!"
              />
            </Option>
          ) : loyalityRewardOptions ? (
            loyalityRewardOptions.map((item) => {
              return (
                <Option
                  className="select-options"
                  key={item.optionId}
                  value={`${item.typeId}-${item.optionsTypeId}-${
                    item.couponCode && item.couponCode.toLowerCase()
                  }`}
                >
                  <span className="select-default-value">
                    {item.optionName}
                  </span>
                </Option>
              );
            })
          ) : (
            ``
          )}
        </Select>
 
        {this.state.loyalityCoupon == "check-coupon"  ? (
          <div className="validate-coupon-container" style={{padding:"5px"}}>
            <h3>{loyaltyRewardDetails && loyaltyRewardDetails.couponCodeTitle}</h3>
            <div className="check-coupon-row">
              <div className="code">
                <Input
                  id="couponCode"
                  placeholder="Type here"
                  onChange={(e) => {
                    this.setState({
                      couponCode: e.target.value,
                    });
                    SessionStorage.couponCode = e.target.value;
                    couponClearMessage();
                    setLoginError(false);
                  }}
                  value={SessionStorage.couponCode ? SessionStorage.couponCode : null}
                />
              </div>
              <div className="check-button-container">
                <Button
                  loading={validateCouponLoading}
                  disabled={validateCouponLoading}
                  type="primary"
                  className="bet-slip-buttons"
                  // className="success"
                  onClick={this.validateCouponCode}
                >
                  Check Coupon
                </Button>
              </div>
            </div>

            {validateCouponError && (
              <div className="notice">
                <Alert message={validateCouponError} type="error" />
              </div>
            )}
            {validateCouponMessage && (
              <div className="notice">
                {/* <Alert message={this.addLineSpace(validateCouponMessage)} type="success" /> */}
                <Popover
                        overlayClassName="more-info-popover"
                        placement="bottom"
                        getPopupContainer={(trigger) => trigger.parentNode}
                        arrowPointAtCenter
                        content={<div> {this.addLineSpace(validateCouponMessage)} </div>}
                        trigger="click"
                      >
                       <div><Alert message={couponName} type="info" icon={<Icon type="info" />} /></div>
                </Popover>
                
              </div>
            )}
          </div>
        ) : this.state.loyalityCoupon == "options" ? (
          <>
            {loadingLoyaltyCoupons ? (
              <Loading text="Loading Options" />
            ) : loyaltyCouponsError ? (
              <Alert message={loyaltyCouponsError} type="error" />
            ) : loyaltyCoupons ? (
              <div id="checkboxes" style={{padding:"5px"}}>
                <h3>Please Choose Your Option.</h3>
                <div className="checkboxes-headline">
                  {loyaltyCoupons.columnList.length > 0 &&
                    Object.values(loyaltyCoupons.columnList).map(
                      (item, key) => {
                        return <div key={key}>{item.columnName}</div>;
                      }
                    )}
                </div>
                {loyaltyCoupons.loyaltyRewardsCoupons.map((item) => {
                  return (
                    <>
                      <div
                        className="loyaity-reward-rows"
                        key={item.couponId}
                        id={item.couponId}
                        style={
                          this.state.expandedReward == item.couponId
                            ? rewardInfoStyle
                            : {}
                        }
                      >
                        <img
                          onClick={(e) =>
                            item.enable && this.showRewardInfo(e, item.couponId)
                          }
                          src={
                            item.enable
                              ? loyaltyRewardDetails && loyaltyRewardDetails.infoEnableImage
                              : loyaltyRewardDetails && loyaltyRewardDetails.infoDisableImage
                          }
                          alt="info"
                        />
                        <label class="radio-button-container">
                          <div className="inner-container">
                            {" "}
                            <div className="checkbox-info">
                              {item.increaseAmount ? item.increaseAmount : "-"}
                            </div>
                            <div className="checkbox-info">
                              {item.coins ? item.coins : "-"}
                            </div>
                          </div>

                          <input
                            type="radio"
                            name="radio"
                            onChange={(e) =>
                              this.SelectLoaylityRewardOption(item.couponId)
                            }
                          />
                          <span class="check" />
                        </label>
                      </div>
                      {this.state.expandedReward == item.couponId && item.conditions &&
                      <p className="expand-description" dangerouslySetInnerHTML={{__html: this.replaceWithBr(item.conditions)}} />
                        // <text className="expand-description">{`${item.conditions}`}</text>
                        }
                    </>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </>
        ) : (
          this.state.loyalityCoupon == "add-coupon" && ""
        )}
        </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    validateCouponMessage: state.general.validateCouponMessage,
    couponName: state.general.couponName,
    validateCouponError: state.general.validateCouponError,
    validateCouponLoading: state.general.validateCouponLoading,
    loyaltyRewardDetails: state.general.loyaltyRewardDetails,
    loadingLoyalityRewards: state.general.loadingLoyalityRewards,
    loyalityRewardOptions: state.general.loyalityRewardOptions,
    loyalityRewardOptionsError: state.general.loyalityRewardOptionsError,
    signedIn: state.auth.signedIn,
    loadingLoyaltyCoupons: state.member.loadingLoyaltyCoupons,
    loyaltyCoupons: state.member.loyaltyCoupons,
    loyaltyCouponsError: state.member.loyaltyCouponsError,
    betTab: state.betSlip.betTab,
    loadingPlaceBet: state.betSlip.loadingPlaceBet,
    betSlipList: state.betSlip.betSlipList,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    couponClearMessage: () => {
      dispatch(couponClearMessage());
    },
    validateCouponReset: () => {
      dispatch(validateCouponReset());
    },
    GetLoyaltyRewardsOptions: () => {
      dispatch(GetLoyaltyRewardsOptions());
    },
    getSignedInLoyalityRewards: () => {
      dispatch(getSignedInLoyalityRewards());
    },
    GetLoyaltyRewardsCoupons: (data) => {
      dispatch(GetLoyaltyRewardsCoupons(data));
    },
    setLoginError: (value) => {
      dispatch(setLoginError(value));
    },
    validateCoupon: (couponCode) => {
      dispatch(validateCoupon(couponCode));
    },
    validateSingleCoupon: () => {
      dispatch(validateSingleCoupon());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoyalityRewards);
